//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import processingVideoTemplate from '@legacy-components/common/processing-video/processing-video.html';

(function() {
  angular.module('curalate').component('processingVideo', {
    template: processingVideoTemplate,
  });
})();
